// Frittstående RFI-panel (poppet ut til egen skjerm). Egen WS-feed (cookie-auth);
// RFI-er flyter via hubbens collab-fanout (org-scope) og flettes monotont.
import { parseRfiOne, mergeRfi, type Rfi } from '@skade/contracts';
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { RfiPanel } from '../ui/rfi.js';
import { byggKontekst } from '../kontekst.js';

export function mountRfiPanel(root: HTMLElement, feed: Feed, _sync: SyncBus, user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const rfis = new Map<string, Rfi>();
  const upsert = (r: Rfi) => {
    const e = rfis.get(r.id); rfis.set(r.id, e ? mergeRfi(e, r) : r);
    if (rfis.size > 500) { const o = [...rfis.values()].sort((a, b) => a.createdMs - b.createdMs)[0]; if (o) rfis.delete(o.id); }
  };
  const panel = new RfiPanel({
    self: user.id,
    getRfis: () => [...rfis.values()],
    publish: (r) => { upsert(r); feed.send?.({ type: 'rfi', rfi: r }); },
    // RFI har ingen posisjonsrad, så «ingen kart i dette vinduet» er uten
    // konsekvens her — avsender/enhet/DTG er like fullt ferdig utfylt.
    kontekst: () => byggKontekst({ bruker: user, posisjon: null, naaMs: Date.now() }),
    naa: () => Date.now(),
  });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
  feed.onCollab?.((m) => { if (m.kind === 'rfi' && m.rfi) { const r = parseRfiOne(m.rfi); if (r) { upsert(r); panel.render(); } } });
  feed.start();
}
